{
  "columnResizer": "Sarakekoon muuttaja",
  "loading": "Ladataan…",
  "loadingMore": "Ladataan lisää…",
  "resizeColumn": "Muuta sarakkeen kokoa",
  "sortAscending": "Lajittelujärjestys: nouseva",
  "sortDescending": "Lajittelujärjestys: laskeva"
}
